module.exports = __webpack_public_path__ + "static/media/location.3695b5c9.svg";